
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SaveConfirmationDialog extends Vue {
  @Prop({ required: true }) show!: boolean;

  get localShow() {
    return this.show;
  }
  set localShow(val: boolean) {
    this.$emit('update:show', val);
  }

  cancel() {
    this.$emit('cancel');
    this.localShow = false;
  }

  confirm() {
    this.$emit('confirm');
    this.localShow = false;
  }
}
